<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="home-page">
      <Header :isRestoCompleto="isRestoCompleto" ></Header>
      <div class="col-lg-8 mx-auto p-3 py-md-5">
        <main>

          <div class="alert alert-primary" role="alert">
  Importante: cuando quieras pasar de campo usa la tecla "Tabulador" y no la tecla "Enter"
</div>

          <div class="row">
    <div class="col-2"  >
      <a href="#" v-if="1==2">
      <p class="h5 mb-2"> <b-icon-arrow-left></b-icon-arrow-left>Atrás</p>
    </a>
    </div>
    <div class="col-8">
      <h3>Datos del restaurante</h3>
    </div>
    <div class="col-2">
      <a href="#" v-on:click="registrarRestaurante()" v-if="!firstTime">
      <p class="h5 mb-2">Siguiente<b-icon-arrow-right></b-icon-arrow-right></p>
    </a>
    </div>
  </div>


       
          
          
         
          <hr class="" />

          <form v-on:submit.prevent="registrarRestaurante">
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Nombre Comercial del establecimiento</label>
              <div class="col-sm-8">
                <input
                autofocus
                data-bs-toggle="tooltip"
                data-bs-html="true"
                :title="tooltipContentNombreComercial" 
                  :placeholder="form.nombre"
                  v-model="form.nombre"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
           
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Descripcion</label>
              <div class="col-sm-8">
                <input
                data-bs-toggle="tooltip"
                data-bs-html="true"
                :title="tooltipContentDescripcion" 
                  :placeholder="form.descripcion"
                  v-model="form.descripcion"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Razón social</label>
              <div class="col-sm-8">
                <input
                  :placeholder="form.razon_social"
                  v-model="form.razon_social"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">CUIT</label>
              <div class="col-sm-8">
                <input
                  :placeholder="form.cuit"
                  v-model="form.cuit"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="mb-4 row">
              <div class="mb-4 col">
                <br />
                <br />

                <br />
                <label class="col-sm-4 col-form-label">Precios</label>
              </div>

              <div class="mb-4 col">
                <br />
                <div class="mb-4 col">
                  <label class="col-sm-4 col-form-label">Desde</label>
                </div>
                <br />
                <div class="mb-4 col">
                  <label class="col-sm-4 col-form-label">Hasta</label>
                </div>
              </div>
              <div class="mb-4 col">
                <br />
                <div class="mb-4 col">
                  <input
                    :placeholder="form.desdePrecio"
                    v-model="form.desdePrecio"
                    type="number"
                    class="form-control"
                    min="0"
                    @mousedown="storePrevValuePrecioDesde"
                    @mouseup="adjustValuePrecioDesde"
                  />
                </div>
                <br />
                <div class="mb-4 col">
                  <input
                    :placeholder="form.hastaPrecio"
                    v-model="form.hastaPrecio"
                    type="number"
                    class="form-control"
                    min="0"
                    @mousedown="storePrevValuePrecioHasta"
                    @mouseup="adjustValuePrecioHasta"
                  />
                </div>
              </div>
            </div>
            <div class="mb-5 row">
              <label class="col-sm-4 col-form-label">Se aceptan mascotas</label>
              <div class="col-sm-8">
                <div class="text-center">
                  <input
                    class="form-check-input"
                    v-model="form.mascotas"
                    type="checkbox"
                    role="switch"
                    id="switchPets"
                  />
                </div>
              </div>
            </div>
            
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Calle</label>
              <div class="col-sm-8">
                <input
                  :placeholder="form.calle"
                  v-model="form.calle"
                  @input="buscarDireccion($event.target.value)"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Altura</label>
              <div class="col-sm-8">
                <input
                  :placeholder="form.altura"
                  v-model="form.altura"
                  @input="buscarDireccion($event.target.value)"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>


            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Codigo postal</label>
              <div class="col-sm-8">
                <input
                  :placeholder="form.codigoPostal"
                  v-model="form.codigoPostal"
                  @input="buscarDireccion($event.target.value)"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>

            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Pais</label>
              <div class="col-sm-8">

                <select
                        class="form-control"
                        formControlName="pais"
                        v-model="paisSelected"
                        @change="cambioPais()"
                      >
                        <option v-for="(pais, index) in paises" :key="index" :value="pais">
                          {{ pais.nombre }}
                        </option>
                      </select>

                
              </div>
            </div>


            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Provincia</label>
              <div class="col-sm-8">

                <select
                        class="form-control"
                        formControlName="provincia"
                        v-model="provinciaSelected"
                        @change="cambioProvincia($event.target.value)"
                      >
                        <option v-for="(provincia, index) in provincias" :key="index" :value="provincia">
                          {{ provincia.nombre }}
                        </option>
                      </select>

              </div>
            </div>
           
     
            <div class="mb-4 row">
              <label class="col-sm-4 col-form-label">Ciudad</label>
              <div class="col-sm-8">

                <select
                        class="form-control"
                        formControlName="Ciudad"
                        v-model="ciudadSelected"
                        @change="cambioCiudad($event.target.value)"
                      >
                        <option v-for="(ciudad, index) in ciudades" :key="index" :value="ciudad">
                          {{ ciudad.nombre }}
                        </option>
                      </select>

              </div>
            </div>


           

            <GoogleMaps
              ref="map"
              :street="form.calle +' '+ form.altura"
              :city="provinciaNombreSelected"
              :state="ciudadNombreSelected"
              :zip="form.codigoPostal"
              :coordinates="form.localizacion"
              :pais="paisNombreSelected"
            />
            <br>
            <hr />

            <div class="alert alert-primary" role="alert">
  Agregar un contacto: Se refiere a las personas que trabajan en el establecimiento y que puedan ser contactadas por los clientes en caso de necesidad o por el staff de Resto UP
</div>

            <h5>Agregar al menos un contacto</h5>
            <table class="table table-responsive table-striped align-middle table-bordered border-primary">
              <thead>
                <tr>
                  <th scope="col">Contacto</th>
                  <th scope="col">Apellido</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Cargo</th>
                  <th scope="col">Whatsapp</th>
                  <th scope="col">Mail</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(contacto,index) in form.contactos" :key="contacto.id">
                  <th scope="row">{{ (index+1) }}</th>
                  <td>{{ contacto.apellido }}</td>
                  <td>{{ contacto.nombre }}</td>
                  <td>{{ contacto.cargo }}</td>
                  <td>{{ contacto.whatsapp }}</td>
                  <td>{{ contacto.mail }}</td>
                  <td>
                    <button type="button" class="btn-primary" v-on:click="borrarContacto(index)">
                      Borrar
                    </button>
                  </td>
                </tr>
                <tr v-if="contactoAgregar!=null" >
                  <th scrope="row"> {{form.contactos && form.contactos.length >0 ?(form.contactos.length+1):1}} </th>
                  <td> <input v-model="contactoAgregar.apellido" class="form-control rounded-0" type="text" name="apellido" placeholder="Apellido"/> </td>
                  <td> <input v-model="contactoAgregar.nombre" class="form-control rounded-0" type="text" name="nombre" placeholder="Nombre"/> </td>   
                  <td> 
                    <select
                  class="form-control rounded-0"
                  v-model="contactoAgregar.cargo"
                  
                >
                  <option
                    v-for="(cargo, index) in cargos"
                    :key="index"
                    :value="cargo"
                  >
                    {{ cargo }} 
                  </option>
                </select>
                  
                  </td> 
                  <td> 
                    
                    <VuePhoneNumberInput class="whatsapp-input" v-model="whatsapp" 
                  @update="resultsWhatsapp = $event" size="sm"
                  :no-example="true"
                  default-country-code="AR"
                  :translations="{
  countrySelectorLabel: '',
  countrySelectorError: '',
  phoneNumberLabel: ''
}" >
</VuePhoneNumberInput>
                
                  
                  
                  
                  </td> 
                  <td> <input v-model="contactoAgregar.mail" class="form-control rounded-0" type="text" name="mail" placeholder="Mail"/> </td>
                  <td>
                    <button type="button" class="btn-primary" v-on:click="agregarContacto()">
                      Guardar
                    </button>
                  </td>
                </tr>
              </tbody>
              
            </table>
            <div class="d-grid d-md-flex justify-content-md-center">
              <button class="btn btn-primary" type="submit" :disabled="isFormEnable" v-if="!firstTime">
                Guardar cambios
              </button>
              <button class="btn btn-primary" type="submit" v-if="firstTime" :disabled="this.form.contactos.length<1"  >
                Siguiente
              </button>
            </div>
          </form>

          
      <PopUpConfirmacionNuevoContacto :show="popupMostrarAgregarContacto" 
      @noconfirmar="contactoAgregar=null;popupMostrarAgregarContacto = false" 
      @confirmar="agregarNuevoContacto();popupMostrarAgregarContacto = false;">
  <template #body>
    <p>{{ popupMostrarAgregarContacto_msg }}</p>
  </template>
</PopUpConfirmacionNuevoContacto>

          
          <PopUp :show="success" @close="success = false;if(firstTime) {goToPageFirstTime('Infraestructura')}">
            <template #body>
              <p>{{ success_msg }}</p>
            </template>
          </PopUp>

          <PopUp :show="error" @close="error = false">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
          <Footer />
        </main>
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
import PopUpConfirmacionNuevoContacto from "../components/PopUpConfirmacionNuevoContacto.vue";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import GoogleMaps from "./GoogleMap.vue";
import { cloneDeep, isEqual } from 'lodash'
import { Tooltip } from 'bootstrap';

export default {
  name: "Perfil",
  components: { Header, Footer, GoogleMaps, PopUp,PopUpConfirmacionNuevoContacto,VuePhoneNumberInput},

  mounted() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    
    tooltipTriggerList.forEach(tooltipTriggerEl => {
      const tooltipInstance = new Tooltip(tooltipTriggerEl);
      this.tooltips.push(tooltipInstance);

      tooltipTriggerEl.addEventListener('show.bs.tooltip', () => {
        this.closeAllTooltipsExcept(tooltipInstance);
      });
    });
},
  data: function () {
    return {
      tooltips: [],
      cargos:['Director','Gerente','Encargado'],
      firstTime: false,
      formChanged: false,
      originalForm: {}, 
      whatsapp:null,
      resultsWhatsapp:null,
      tooltipContentNombreComercial: `<em>El nombre comercial es el nombre de cómo publicas tu negocio o, por ejemplo, </em>  
      <strong>"El Faro de Garrido",</strong>
      <strong>"La Parrilla de Mirtha", </strong>
      <strong>etc. </strong>
      `,
      tooltipContentDescripcion: `<em> La descripción deber poner una frase que indique al cliente cual es tu especialidad </em>
        <strong>"Pizza y empanadas",</strong>
      <strong>"Pescado y mariscos"</strong>
      <em> o también una frase que resuma un perfil de tu negocio: </em>
      <strong>"Un buen lugar de reunión",</strong>
      <strong>"Comida Peruana",</strong>
      <strong>etc. </strong>
      `,
      prevValuePrecioDesde: null,
      prevValuePrecioHasta: null,
      popupMostrarAgregarContacto_msg: `
      ¿Quiere agregar otro contacto?
      `,
      popupMostrarAgregarContacto:false,
      form: {
        nombre: "",
        razon_social: "",
        descripcion: "",
        cuit: "",
        desdePrecio: 0,
        hastaPrecio: "",
        mascotas: false,
        calle: "",
        altura: "",
        provincia: "",
        ciudad: "",
        codigoPostal: "",
        latitud: 0,
        longitud: 0,
        localizacion: Object,
        contactos: [],
      },
      restoLoad:null,
      paises:[],
      provincias:[],
      ciudades:[],
      ciudadSelected: "",
      provinciaSelected: "",
      paisSelected: "",
      provinciaNombreSelected: "",
      paisNombreSelected: "",
      ciudadNombreSelected: "",
      usuario_id: "",
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      isRestoCompleto:false,
      contactoAgregar: new Object()
    };
  },
  methods: {
    adjustValuePrecioDesde() {

      if(this.form.hastaPrecio!=null){
      if(this.form.desdePrecio>this.form.hastaPrecio){
        this.form.desdePrecio=this.form.hastaPrecio;
        return;
      }
    }


    const difference = this.form.desdePrecio - this.prevValuePrecioDesde;
    if (difference > 0) { 
      this.form.desdePrecio = this.prevValuePrecioDesde + 1000;
    } else if (difference < 0) {
      this.form.desdePrecio = this.prevValuePrecioDesde - 1000;
    }
    this.prevValuePrecioDesde = this.form.desdePrecio;
  },
  storePrevValuePrecioDesde() {
    this.prevValuePrecioDesde = Number(this.form.desdePrecio);
  },
  adjustValuePrecioHasta() {
    if(this.form.desdePrecio!=null){
      if(this.form.hastaPrecio<this.form.desdePrecio){
        this.form.hastaPrecio=this.form.desdePrecio;
        return;
      }
    }

    const difference = this.form.hastaPrecio - this.prevValuePrecioHasta;
    if (difference > 0) { 
      this.form.hastaPrecio = this.prevValuePrecioHasta + 1000;
    } else if (difference < 0) {
      this.form.hastaPrecio = this.prevValuePrecioHasta - 1000;
    }
    console.log(this.form.hastaPrecio)
    this.prevValuePrecioHasta = this.form.hastaPrecio;
  },
  storePrevValuePrecioHasta() {
    this.prevValuePrecioHasta = Number(this.form.hastaPrecio);
  },
    closeAllTooltipsExcept(exceptInstance) {
      this.tooltips.forEach(tooltip => {
        if (tooltip !== exceptInstance) {
          tooltip.hide();
        }
      });
  },
    cambioPais(){
      this.cargarProvincias();
      if(this.paisSelected){
        this.paisNombreSelected=this.paisSelected.nombre;
      }

      this.buscarDireccion();
    }, 

    cambioCiudad(){
      if(this.ciudadSelected){
        this.ciudadNombreSelected=this.ciudadSelected.nombre;
      }
      this.buscarDireccion();
    }, 
   

    cambioProvincia(){
      this.cargarCiudades();
      if(this.provinciaSelected){
        this.provinciaNombreSelected=this.provinciaSelected.nombre;
      }
      this.buscarDireccion();
    }, 
   

    async cargarPaises() { 
      this.paises=[];
     await axios.get("/getPaisesFilter/?pais=").then((data) => {
        if (data.status == 200) {
          this.paises = data.data;
        } else {
          this.error = true;
          this.error_msg = "No se ha podido cargar los paises";
        }
      });
    },
    async cargarProvincias() { 
      this.provincias=[];
      this.ciudadSelected="";
      this.ciudadNombreSelected="";
      this.provinciaSelected="";
      this.provinciaNombreSelected="";
     await axios.get("/provincias?pais="+this.paisSelected.id).then((data) => {
        if (data.status == 200) {
          this.provincias = data.data.items;
        } else {
          this.error = true;
          this.error_msg = "No se ha podido cargar los paises";
        }
      });
    },
    async cargarCiudades() { 
      this.ciudades=[];
      this.ciudadSelected="";
      this.ciudadNombreSelected="";
     await axios.get("/ciudades?provincia="+this.provinciaSelected.id).then((data) => {
        if (data.status == 200) {
          this.ciudades = data.data.items;
        } else {
          this.error = true;
          this.error_msg = "No se ha podido cargar los paises";
        }
      });
    },
    registrarRestaurante() {
      if (this.form.desdePrecio < 0) {
        this.error = true;
        this.error_msg = "El valor minimo del precio debe ser un dato numerico y positivo";
        return;
      }
      if (this.form.hastaPrecio < 0) {
        this.error = true;
        this.error_msg = "El valor maximo del precio debe ser un dato numerico y positivo";
        return;
      }
      if(this.form.contactos.length == 0) {
        this.error = true;
        this.error_msg = "Debe cargar al menos un contacto";
        return;
      }

      if(this.form.contactos.length > 3 ) {
        this.error = true;
        this.error_msg = "Los contactos no deben ser mas de 3";
        return;
      }

  


      if (
        this.form.nombre == "" || !this.form.nombre ||
        this.form.razon_social == "" || !this.form.razon_social ||
        this.form.descripcion == "" || !this.form.descripcion ||
        this.form.cuit == "" || !this.form.cuit ||
        this.form.desdePrecio == "" || !this.form.desdePrecio ||
        this.form.hastaPrecio == "" || !this.form.hastaPrecio ||
        this.form.contactos.length == 0 ||
        this.form.codigoPostal == ""  || !this.form.codigoPostal ||
        this.paisSelected == "" || !this.paisSelected ||
        this.provinciaSelected == "" || !this.provinciaSelected  ||
        this.ciudadSelected == "" || !this.ciudadSelected 
      ) {
        this.error = true;
        this.error_msg = "Completa todos los campos por favor";
        return;
      }


      if(
      (this.form.latitud==undefined || this.form.latitud==null || this.form.latitud==0) ||
      this.form.longitud==undefined || this.form.longitud==null || this.form.longitud==0

      ) {
        this.error = true;
        this.error_msg = "Por favor aguarde a que se cargue la direccion en el mapa";
        return;
      }
      

      if(parseInt(this.form.desdePrecio) > parseInt(this.form.hastaPrecio)) {
        this.error = true;
        this.error_msg = "El precio minimo no puede ser mayor al precio maximo";
        return;
      }


      axios
        .get("/getUserByMail")
        .then((data) => {
          if (data.status == 200) {
            this.error = false;
            let resto = {
              nombre: this.form.nombre,
              usuario_id: data.data.id,
              razon_social: this.form.razon_social,
              descripcion: this.form.descripcion,
              pais: this.paisSelected.id,
              codigoPostal: this.form.codigoPostal,
              cuit: this.form.cuit,
              desdePrecio: this.form.desdePrecio,
              hastaPrecio: this.form.hastaPrecio,
              mascotas: this.form.mascotas,
              calle: this.form.calle,
              altura: this.form.altura,
              provincia: this.provinciaSelected.id,
              ciudad: this.ciudadSelected.id,
              id: this.form.restauranteId,
              latitud: this.form.latitud,
              longitud: this.form.longitud,
              contactos: this.form.contactos
            };

            axios
              .post("/modificarRestaurante", resto)
              .then((data) => {
                if (data.status == 200) {
                  this.success = true;
                  this.success_msg =
                    "Informacion del restaurante guardada con exito!";
                  this.cargarRestaurante();
                  
                }
              });
          }
        });
    },
    buscarDireccion(value, time = 5000) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if(this.form.calle && this.form.altura && this.provinciaNombreSelected && this.ciudadNombreSelected && this.paisNombreSelected) {
          this.form.latitud = 0;
          this.form.longitud = 0;
          this.$refs.map.handleFormSubmit();
          this.inputValue = value;
        }
        
      }, time)
    },
    agregarNuevoContacto(){
       this.contactoAgregar = new Object();
    },
    agregarContacto() {

      if(
      this.resultsWhatsapp != null && 
     ( !this.resultsWhatsapp.isValid )
      
      ){
        this.error = true;
        this.error_msg = "Telefono invalido";
        return;
      }


      if(!this.contactoAgregar.apellido || 
        !this.contactoAgregar.nombre || 
        !this.contactoAgregar.cargo || 
        !this.whatsapp || 
        !this.contactoAgregar.mail) {
          this.error = true;
          this.error_msg = "Para agregar un contacto debe llenar todos los campos"
        return;
      }
      let telefono=this.resultsWhatsapp.formatInternational.trim().replace(/\s+/g, '')+"";
      this.contactoAgregar.whatsapp=telefono;
      this.form.contactos.push(this.contactoAgregar);
      this.popupMostrarAgregarContacto=true;
       
    },
    borrarContacto(index) {
      this.form.contactos.splice(index, 1);

      this.contactoAgregar = new Object();
    },

    async selectedPaisProvinciaCiudad(data,ciudad){
      
      let paisId=data.provincia.paisId;

this.paises.forEach(element => {
  if(element.id==paisId){
    this.paisSelected=element;
    this.paisNombreSelected=element.nombre;
  }
});


await this.cargarProvincias();

this.provincias.forEach(element => {
 if(element.id==data.provincia.id){
    this.provinciaSelected=element;
    this.provinciaNombreSelected=element.nombre;
  } 
});

await this.cargarCiudades();
this.ciudades.forEach(element => {
 if(element.id==ciudad){
    this.ciudadSelected=element;
    this.ciudadNombreSelected=element.nombre;
  } 
});

    },
    async cargarRestaurante() {
      
     await this.cargarPaises();

      axios
      .get("/restaurante/mail")
      .then((data) => {
        if (data.status == 200) {
          if(data.data.pasosCompletadosRegistro==8){
            this.isRestoCompleto = true;
          }

          if(data.data.ciudad!=null){
            axios
      .get("/ciudades?id="+data.data.ciudad.id)
      .then((dataCiudad) => {
        if (dataCiudad.status == 200) {
          this.selectedPaisProvinciaCiudad(dataCiudad.data.items[0],data.data.ciudad.id);
        }
      })
          
          }
          


          this.restoLoad=data.data;
          this.form.nombre = data.data.nombre;
          this.form.restauranteId = data.data.id;
          this.form.razon_social = data.data.razon_social;
          this.form.descripcion = data.data.descripcion;
          this.form.desdePrecio = data.data.desdePrecio;
          this.form.hastaPrecio = data.data.hastaPrecio;
          this.form.capacidad = data.data.capacidad;
          this.form.cuit = data.data.cuit;
          this.form.mascotas = data.data.mascotas;
          this.form.calle = data.data.calle?data.data.calle:"";
          this.form.altura = data.data.altura;
          this.form.ciudad = data.data.ciudad;
          this.form.latitud = data.data.localizacion?.latitud;
          this.form.longitud = data.data.localizacion?.longitud;
          this.form.contactos = data.data.contactos;
          this.form.codigoPostal = data.data.codigoPostal;
          if (this.form.latitud || this.form.longitud) {
            this.$refs.map.setPosition(this.form.latitud, this.form.longitud);
          } else {
            this.form.localizacion = undefined;
          }
          this.originalForm = cloneDeep(this.form);
        }
      })
      .catch((e) => {
        console.log(e)
        this.error = true;
        this.error_msg =
          "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
      })
      .finally(() => {
       
      });
    },
    goToPageFirstTime(page) {
      this.$router.push({ name: page, params: { firstTime: true } });
    },
  },

  computed: {
    isFormEnable() {
      // check if it's original value
      if (!isEqual(this.form, this.originalForm)) return false;

      return true;
    },
  },
  
  beforeMount() {
    this.cargarRestaurante();
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import "../../node_modules/vue2-timepicker/dist/VueTimepicker.css";
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
 .whatsapp-input {
    width: 200px !important;
} 


</style>
